class VrCollectionNavigation extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.vr-collection-navigation__scroll');
    if (!this.viewport) return;
    this.didCenter = false;
    this.viewport.addEventListener('scroll', this.updateOverflow, { passive: true });
    this.addEventListener('click', this.handleRailClick);
    this.observer = new ResizeObserver(this.measure);
    this.observer.observe(this.viewport);
    const list = this.querySelector('.vr-collection-navigation__list');
    if (list) this.observer.observe(list);
    this.frame = requestAnimationFrame(this.measure);
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.observer?.disconnect();
    this.viewport?.removeEventListener('scroll', this.updateOverflow);
    this.removeEventListener('click', this.handleRailClick);
  }

  measure = () => {
    if (!this.viewport?.clientWidth) return;
    if (!this.didCenter) {
      const current = this.querySelector('[aria-current="page"]');
      if (current) {
        const offset = current.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
        this.viewport.scrollLeft += offset - (this.viewport.clientWidth - current.offsetWidth) / 2;
      }
      this.didCenter = true;
    }
    this.updateOverflow();
  };

  updateOverflow = () => {
    if (!this.viewport) return;
    const previous = this.querySelector('[data-vr-scroll="previous"]');
    const next = this.querySelector('[data-vr-scroll="next"]');
    if (previous) previous.hidden = this.viewport.scrollLeft < 2;
    if (next) next.hidden = this.viewport.scrollWidth - this.viewport.clientWidth - this.viewport.scrollLeft < 2;
  };

  handleRailClick = (event) => {
    const button = event.target.closest?.('[data-vr-scroll]');
    if (!button || !this.contains(button) || !this.viewport) return;
    const direction = button.dataset.vrScroll === 'previous' ? -1 : 1;
    this.viewport.scrollBy({
      left: direction * this.viewport.clientWidth * 0.7,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  };
}

class VrCollectionSort extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }

  handleChange(event) {
    if (!(event.target instanceof HTMLSelectElement) || event.target.name !== 'sort_by') return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }
}

if (!customElements.get('vr-collection-navigation')) {
  customElements.define('vr-collection-navigation', VrCollectionNavigation);
}
if (!customElements.get('vr-collection-sort')) {
  customElements.define('vr-collection-sort', VrCollectionSort);
}

